/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/api/v1": {
    get: operations["AppController_home"];
  };
  "/api/v1/me": {
    get: operations["AppController_me"];
  };
  "/api/v1/shops/{shop}": {
    get: operations["AppController_ensureShops"];
  };
  "/api/v1/users/{firebaseUserId}": {
    post: operations["UserController_updateUser"];
  };
  "/api/v1/users/{firebaseUserId}:beginUploadAvatar": {
    post: operations["UserController_beginUploadAvatar"];
  };
  "/shopify/auth": {
    /** Shopify OAuth endpoint */
    get: operations["ShopifyOAuthController_authorize"];
  };
  "/shopify/callback": {
    /** Shopify OAuth callback */
    get: operations["ShopifyOAuthController_callback"];
  };
  "/shopify/customer-auth": {
    post: operations["AuthController_customerAuth"];
  };
  "/shopify/admin-auth": {
    post: operations["AuthController_adminAuth"];
  };
  "/api/v1/shopify/products/count": {
    get: operations["ShopifyApiController_countProducts"];
  };
}

export interface components {
  schemas: {
    UpdateUserRequest: {
      /** @description optional: username to use */
      username?: string;
      /** @description optional: set avatar from image url, can be external or uploaded to firebase storage */
      avatarUrl?: string;
    };
    UserProfileResponse: {
      mappedEmail: string;
      shop: string;
      uid: string;
      avatar?: string;
      username: string;
      /** @example 2021-08-09T00:45:02.508Z */
      createdAt: string;
      /** @example 2021-08-09T00:45:02.508Z */
      updatedAt: string;
    };
    BeginUploadAvatarResponse: {
      id: string;
      uploadUrl: string;
    };
    OAuthResponse: {
      permission_grant_needed: boolean;
      client_id?: string;
      scope?: string;
      nonce?: string;
    };
    OAuthCallbackResponse: {
      embedded: boolean;
      client_id: string;
    };
    CustomerAuthRequest: {
      shop: string;
      customerAccessToken: string;
    };
    CustomerAuthInfo: {
      id: string;
      email: string;
      phone?: string;
      firstName?: string;
      lastName?: string;
      acceptsMarketing: boolean;
    };
    CustomerAuthResponse: {
      info: components["schemas"]["CustomerAuthInfo"];
      custom_token: string;
    };
    AdminAuthInfo: {
      id: string;
      email: string;
    };
    AdminAuthResponse: {
      info: components["schemas"]["AdminAuthInfo"];
      custom_token: string;
    };
    ProductCountResponse: {
      count: number;
    };
  };
}

export interface operations {
  AppController_home: {
    parameters: {};
    responses: {
      200: unknown;
    };
  };
  AppController_me: {
    parameters: {};
    responses: {
      200: unknown;
    };
  };
  AppController_ensureShops: {
    parameters: {
      path: {
        shop: unknown;
      };
    };
    responses: {
      200: unknown;
    };
  };
  UserController_updateUser: {
    parameters: {
      path: {
        firebaseUserId: unknown;
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["UserProfileResponse"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["UpdateUserRequest"];
      };
    };
  };
  UserController_beginUploadAvatar: {
    parameters: {
      path: {
        firebaseUserId: unknown;
      };
    };
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["BeginUploadAvatarResponse"];
        };
      };
    };
  };
  /** Shopify OAuth endpoint */
  ShopifyOAuthController_authorize: {
    parameters: {};
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["OAuthResponse"];
        };
      };
    };
  };
  /** Shopify OAuth callback */
  ShopifyOAuthController_callback: {
    parameters: {};
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["OAuthCallbackResponse"];
        };
      };
    };
  };
  AuthController_customerAuth: {
    parameters: {};
    responses: {
      201: {
        content: {
          "application/json": components["schemas"]["CustomerAuthResponse"];
        };
      };
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["CustomerAuthRequest"];
      };
    };
  };
  AuthController_adminAuth: {
    parameters: {
      header: {
        Authorization: string;
      };
    };
    responses: {
      201: {
        content: {
          "application/json": components["schemas"]["AdminAuthResponse"];
        };
      };
    };
  };
  ShopifyApiController_countProducts: {
    parameters: {};
    responses: {
      200: {
        content: {
          "application/json": components["schemas"]["ProductCountResponse"];
        };
      };
    };
  };
}

export interface external {}

export namespace ApiPaths {
  export const AppController_home = {
    url: "/api/v1" as const,
    method: "get" as const,
  };
  export const AppController_me = {
    url: "/api/v1/me" as const,
    method: "get" as const,
  };
  export const AppController_ensureShops = {
    url: "/api/v1/shops/{shop}" as const,
    method: "get" as const,
  };
  export const UserController_updateUser = {
    url: "/api/v1/users/{firebaseUserId}" as const,
    method: "post" as const,
  };
  export const UserController_beginUploadAvatar = {
    url: "/api/v1/users/{firebaseUserId}:beginUploadAvatar" as const,
    method: "post" as const,
  };
  export const ShopifyOAuthController_authorize = {
    url: "/shopify/auth" as const,
    method: "get" as const,
  };
  export const ShopifyOAuthController_callback = {
    url: "/shopify/callback" as const,
    method: "get" as const,
  };
  export const AuthController_customerAuth = {
    url: "/shopify/customer-auth" as const,
    method: "post" as const,
  };
  export const AuthController_adminAuth = {
    url: "/shopify/admin-auth" as const,
    method: "post" as const,
  };
  export const ShopifyApiController_countProducts = {
    url: "/api/v1/shopify/products/count" as const,
    method: "get" as const,
  };
}
